var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field__content"},[(!_vm.readonly)?[_vm._v(" "+_vm._s(_vm.val)+" ")]:[_vm._v(_vm._s(_vm.val || '无'))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }